import { useContext } from "react";
import { deleteClientFromDatabase } from "../../../data/clients/repository/ClientsRepository";
import { ClientContext } from "../../../context/ClientContext";

export function useDeleteClient(closeModal) {
  const { selectedClient, deleteClient, clearSuccess } = useContext(ClientContext);

  const deleteClientById = async () => {
    if (!selectedClient) return;
    try {
      const response = await deleteClientFromDatabase(selectedClient.id);
      if (response) {
        deleteClient(true);
      } else {
        deleteClient(false);
        console.error("Failed to delete client.");
      }
      closeModal();
    } catch (error) {
      deleteClient(false);
      console.error("Error deleting client:", error);
    }
  };
  return {
    selectedClient,
    deleteClientById
  };
}